import * as Sentry from "@sentry/astro";

Sentry.init({
  dsn: "https://e365b5366549aa0346b2d6d01076faab@o4508869364350976.ingest.de.sentry.io/4508869367758928",
  debug: false,
  environment: import.meta.env.PUBLIC_VERCEL_ENV,
  release: import.meta.env.PUBLIC_VERCEL_GIT_COMMIT_SHA,
  tracesSampleRate: 1,
  integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1,
});